import { AdaptiveSheet } from '../common/AdaptiveSheet';
import { DefensePlanBidsView } from './DefensePlanBidsView.web';

// Phone and tablet host for DefensePlanBidsView. The desktop shell puts the
// same view in a CompanionPanel instead (DefensePlanPanel.web.tsx branches on
// useDesktopShell()), the way it does for events.
export function DefensePlanBidsSheet({
  visible,
  planId,
  bundleId,
  onClose,
  onFindVendors,
}: {
  visible: boolean;
  planId: string | null;
  bundleId: string | null;
  onClose: () => void;
  onFindVendors?: (bundleId: string) => void;
}) {
  return (
    <AdaptiveSheet isOpen={visible} onRequestClose={onClose} onDismiss={onClose} dialogWidth={480}>
      <AdaptiveSheet.ScrollView testID="plan-bids-sheet">
        {planId && bundleId ? (
          <DefensePlanBidsView
            planId={planId}
            bundleId={bundleId}
            onFindVendors={onFindVendors ? () => onFindVendors(bundleId) : undefined}
          />
        ) : null}
      </AdaptiveSheet.ScrollView>
    </AdaptiveSheet>
  );
}
